import { observer } from "mobx-react-lite";
import React from "react";
import AppState, { POPUPS, SCREENS } from "../../js/AppState";
import TopBar from '../TopBar/TopBar';
import { getUrlVar } from "react-sdk/utils";

import ScreenLoading from "../ScreenLoading/ScreenLoading";

import { useRef, useState } from "react";
import ScaleManager from "react-sdk/ScaleManager";
import { CSSTransition } from "react-transition-group";
import ScreenPresentation from "../ScreenPresentation/ScreenPresentation";
import ScreenIntro from "../ScreenIntro/ScreenIntro";
import Notifs from "../shared/Notifs/Notifs";
import PresentationHelper from "../../js/PresentationHelper";

import PopupSettings from "../PopupSettings/PopupSettings";
import SpeechHelper from "../../js/SpeechHelper";

import './App.css';

const App = () => {
  return (
    <div className="App" style={ScaleManager.style}>

      <div className='Header'>
      { AppState.screen != SCREENS.LOADING && <TopBar pauseAvailable={true} untabulable={true} /> }
      </div>
      {AppState.screen === SCREENS.LOADING && <ScreenLoading />}
      {AppState.loaderOverlay && <ScreenLoading />}
      {AppState.screen === SCREENS.INTRO && <ScreenIntro />}

      { AppState.screen === SCREENS.PRESENTATION && <ScreenPresentation /> }

      {AppState.loaderOverlay && <div className="Loader-overlay"><ScreenLoading /></div>}

      { AppState.popup === POPUPS.SETTINGS && <PopupSettings/> }

      { !getUrlVar("sequence") && <div className="error-message">ERROR : NO SEQUENCE IN URL_PARAMETERS</div>}

      <Notifs />
    </div>
  )
}

export default observer(App);
